import i18n from "i18next";

/**
 * Map the current i18n language code to the UI language name expected by the
 * AI chat API. Falls back to English for unknown languages.
 */
const getUiLanguageName = (language?: string): string => {
  const lang = language ?? i18n.language;
  switch (lang) {
    case "en":
      return "English";
    case "id":
      return "Indonesian";
    case "jp":
      return "Japanese";
    case "th":
      return "Thai";
    case "vn":
      return "Vietnamese";
    default:
      return "English";
  }
};

export default getUiLanguageName;
